import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {labelBeagleHistoryCard} from "./LabelBeagleHistoryCard";


function createNutrientData(nutrientLabel, nutrientNumber) {
    nutrientNumber = nutrientNumber.toFixed(1);
    return {nutrientLabel, nutrientNumber};
}

const useStyles = makeStyles({
    table: {
        minWidth: 100,
    },
    blah: {
        fontWeight: "lighter",
        fontSize: "larger",
    },
    styleNutrientLabel: {
        fontSize: "larger",
        textAlign: "center",
    },
    styleNutrientNumber: {
        fontWeight: "bold",
        fontSize: "larger",
        textAlign: "right",
    },
});


export default function BeagleHistoryCardTable(props) {

    const classes = useStyles();

    const langPref = props.beagleLanguagePreference;
    const labelNutrient = labelBeagleHistoryCard.labelNutrient[langPref];
    const labelRemoval = labelBeagleHistoryCard.labelRemoval[langPref];

    const cropCalculationRows = [
        createNutrientData('N', props.beagleCropCalculation.nutrient.n),
        createNutrientData('P\u2082O\u2085', props.beagleCropCalculation.nutrient.p2o5),
        createNutrientData('K\u2082O', props.beagleCropCalculation.nutrient.k2o),
    ];
    if (props.beagleCropCalculation.nutrient.s !== undefined && props.beagleCropCalculation.nutrient.s !== 0) {
        cropCalculationRows.push(createNutrientData('S', props.beagleCropCalculation.nutrient.s));
    }
    cropCalculationRows.push(createNutrientData('P', props.beagleCropCalculation.nutrient.p));
    cropCalculationRows.push(createNutrientData('K', props.beagleCropCalculation.nutrient.k));


    return (
        <Table size="small" className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell align="center" className={classes.blah}>{labelNutrient}</TableCell>
                    <TableCell align="right">{labelRemoval}, {props.beagleCropCalculation.nutrientUnit}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {cropCalculationRows.map((row) => (
                    <TableRow key={'ha' + row.nutrientLabel}>
                        <TableCell align="center" className={classes.styleNutrientLabel}>{row.nutrientLabel}</TableCell>
                        <TableCell className={classes.styleNutrientNumber}>{row.nutrientNumber}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
